import React, { useEffect } from 'react'
// import { fetchData as AccMast } from '../../Redux/Slices/Masters/AccMastSlice';
// import { fetchData as ShapMast } from '../../Redux/Slices/Masters/ShapMastSlice';
// import { fetchData as CutMast } from '../../Redux/Slices/Masters/CutMastSlice';
import { useDispatch, useSelector } from 'react-redux';
// import { fetchData as ClarityMast } from '../../Redux/Slices/Masters/ClarityMastSlice';
import { selectLogin } from '../../Redux/Slices/Utility/LoginSlice';
// import { fetchData as ColorMast } from '../../Redux/Slices/Masters/ColMastSlice'; 
import { fetchMenuPermition } from '../../Redux/Slices/Utility/MenuPermition'; 
import { fetchData as MenuMast } from '../../Redux/Slices/Masters/MenuMastSlice';
import { fetchData as ColumnConfigSlice } from '../../Redux/Slices/Utility/ColumnConfigSlice'
import { fetchData as DropDownSlice } from '../../Redux/Slices/Utility/DropDownSlice';
import { fetchData as ApiSettingSlice } from '../../Redux/Slices/Masters/ApiSettingSlice';

function LoadAllMast() {
  const login = useSelector(selectLogin)
  const dispatch = useDispatch()
  useEffect(() => {
    if (login) {
      dispatch(fetchMenuPermition())
      dispatch(MenuMast())
      // dispatch(AccMast())
      // dispatch(ShapMast())
      // dispatch(CutMast())
      // dispatch(ColorMast())
      // dispatch(ClarityMast())
      dispatch(ColumnConfigSlice())
      dispatch(DropDownSlice())
      dispatch(ApiSettingSlice(true))

    }

  }, [login])

  return <></>
}

export default LoadAllMast